import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { CustomThemeProvider } from './contexts/ThemeContext';
import { GlobalStyle } from './styles/GlobalStyle';
import { Navigation } from './components';
import { PageLoader } from './components/PageLoader';
import CustomCursor from './components/CustomCursor';
import {
  About,
  Projects,
  ProjectDetail,
  Articles,
  ArticleDetail,
  Contact
} from './pages';
import { AdminDashboard } from './admin/pages/AdminDashboard';
import { ProjectsAdmin } from './admin/pages/ProjectsAdmin';
import { ProjectForm } from './admin/pages/ProjectForm';
import { ArticlesAdmin } from './admin/pages/ArticlesAdmin';
import { ArticleForm } from './admin/pages/ArticleForm';
import { ExperiencesAdmin } from './admin/pages/ExperiencesAdmin';
import { ExperienceForm } from './admin/pages/ExperienceForm';
import { ImageTrailAdmin } from './admin/pages/ImageTrailAdmin';
import { AuthGuard } from './admin/components/AuthGuard';
import CursorImageTrail from './components/CursorImageTrail';
import FloatingAppBanner from './components/FloatingAppBanner';

export let activeCo = null;

function CoParamPersistor() {
  const location = useLocation();
  React.useEffect(() => {
    const co = new URLSearchParams(location.search).get('co');
    if (co) {
      activeCo = co.toLowerCase();
    } else if (activeCo) {
      // Re-append co to the URL silently without triggering navigation
      const params = new URLSearchParams(location.search);
      params.set('co', activeCo);
      const newUrl = `${location.pathname}?${params.toString()}`;
      window.history.replaceState(null, '', newUrl);
    }
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  return (
    <CustomThemeProvider>
      <Router>
        <GlobalStyle />
        <PageLoader />
        <CoParamPersistor />
        <CursorImageTrail src="/logo.png" size={72} threshold={80} />
        <CustomCursor />
        <FloatingAppBanner />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<><Navigation /><About /></>} />
          <Route path="/projects" element={<><Navigation /><Projects /></>} />
          <Route path="/projects/:id" element={<><Navigation /><ProjectDetail /></>} />
          <Route path="/articles" element={<><Navigation /><Articles /></>} />
          <Route path="/articles/:id" element={<><Navigation /><ArticleDetail /></>} />
          <Route path="/contact" element={<><Navigation /><Contact /></>} />

          {/* Admin Routes */}
          <Route path="/admin" element={<AuthGuard><AdminDashboard /></AuthGuard>} />
          <Route path="/admin/projects" element={<AuthGuard><ProjectsAdmin /></AuthGuard>} />
          <Route path="/admin/projects/new" element={<AuthGuard><ProjectForm /></AuthGuard>} />
          <Route path="/admin/projects/:id/edit" element={<AuthGuard><ProjectForm /></AuthGuard>} />
          <Route path="/admin/articles" element={<AuthGuard><ArticlesAdmin /></AuthGuard>} />
          <Route path="/admin/articles/new" element={<AuthGuard><ArticleForm /></AuthGuard>} />
          <Route path="/admin/articles/:id/edit" element={<AuthGuard><ArticleForm /></AuthGuard>} />
          <Route path="/admin/experiences" element={<AuthGuard><ExperiencesAdmin /></AuthGuard>} />
          <Route path="/admin/experiences/new" element={<AuthGuard><ExperienceForm /></AuthGuard>} />
          <Route path="/admin/experiences/:id/edit" element={<AuthGuard><ExperienceForm /></AuthGuard>} />
          <Route path="/admin/personalize" element={<AuthGuard><ImageTrailAdmin /></AuthGuard>} />
        </Routes>
      </Router>
    </CustomThemeProvider>
  );
}

export default App;
